import { createRouter, createWebHashHistory } from 'vue-router'
import ngApp from '../views/ngApp.vue'
import vueApp from '../views/vueApp.vue'
import config from '@/appsConfig'
const routes = [
  {
    path: '/',
    name: 'home',
    redirect:
      process.env.NODE_ENV === 'development'
        ? `${config['ngApp'].baseroute}/event/sign-in`
        : config['ngApp'].baseroute,
    // redirect:
    //   process.env.NODE_ENV === 'development'
    //     ? `${config['vueApp'].baseroute}`
    //     : config['vueApp'].baseroute,
  },
  {
    // vue-router@4.x path的写法为：'/my-page/:page*'
    path: '/angular/:page*',
    name: 'ngApp',
    component: ngApp,
  },
  {
    path: '/vue/:page*',
    name: 'vueApp',
    component: vueApp,
  },
]

const router = createRouter({
  history: createWebHashHistory('/'),
  routes,
})
// let fistLoad = true
// router.beforeEach((to, from) => {
//   if (location.hostname === 'localhost' && fistLoad) {
//     if (!to.path.startsWith(config['ngApp'].baseroute) && from.path != '/') {
//       const globalData = microApp.getGlobalData()
//       const postData = Object.assign(globalData, {
//         redirectPath: to.path,
//       })
//       microApp.setGlobalData(postData)
//       fistLoad = false
//       router.replace({ path: `${config['ngApp'].baseroute}/event/sign-in` })
//     }
//   }
//   fistLoad = false
// })

export default router
